import ArtifactGroupType from "../base/ArtifactGroupType";


const TheArtOfChaDao = {
  id: '113',
  name: 'The Art Of Cha Dao',
  groupIcon: 'WhispersOfJade',
  type: ArtifactGroupType.WHISPERS_OF_JADE,
  icon: 'TheArtOfChaDao',
  power: 25,
  gameId: 'TheArtOfChaDao'
};

export default TheArtOfChaDao;
